export type UUID = string;

export const NIL_UUID: UUID = 'nil-uuid';
